export const skillGroups = [
  {
    name: "languages",
    skills: ["python", "javascript", "typescript", "java", "c", "html/css", "r", "bash", "latex"],
  },
  {
    name: "frameworks & libraries",
    skills: ["react", "react native", "next.js", "flask", "django", "pytorch", "selenium", "jinja2", "numpy", "pandas", "langchain"],
  },
  {
    name: "cloud & devops",
    skills: ["aws s3", "aws ec2", "aws iam", "aws cli", "docker", "github actions", "ci/cd", "digitalocean", "rest apis", "git / github"],
  },
  {
    name: "databases",
    skills: ["sql", "sqlite", "mongodb"],
  },
  {
    name: "game & interactive",
    skills: ["unity", "c#", "game prototyping", "gameplay systems"],
  },
  {
    name: "tools",
    skills: ["figma", "jira", "confluence"],
  },
];
